import { Channel, Program } from '../../types'
import { useProgramsPerDay } from '../../hooks'
import { ProgramItem } from './program'
import { getResource } from '../../utils'
import { useIsInView } from '@ddg-frontend/fe-essentials'

interface ProgramProps {
  daysInterval?: number
  timelineInterval?: number
  channel: Channel
  day: string
  onProgramClick: (
    id: number | undefined,
    channel: Channel | undefined,
    date?: string | undefined
  ) => void
}

export const ChannelProgramming = ({
  channel,
  day,
  onProgramClick,
}: ProgramProps) => {
  const minutePx = 200 / 30
  const [viewRef, isInView] = useIsInView<HTMLDivElement>({
    rootMargin: '0px',
    threshold: 0.01,
    triggerOnce: true,
  })

  const { data, error, isLoading } = useProgramsPerDay(
    channel.callLetter,
    day,
    isInView
  )

  return (
    <div
      className={`channel-day  ${isLoading ? 'loading' : ''}`}
      style={{
        minWidth: `${minutePx * 24 * 60}px`,
        height: '100px',
      }}
      ref={viewRef}
    >
      {error ? (
        <div className="error">
          <div className="form-message inline" data-type="alert">
            <div>{getResource('ChannelProgramming.Error')}</div>
          </div>
        </div>
      ) : (
        <ul className="program-list flex">
          {data?.map((program: Program, index: number) => {
            return (
              <ProgramItem
                program={program}
                channel={channel}
                day={day}
                onProgramClick={onProgramClick}
                key={program.id}
                isLastProgram={index === data.length - 1}
              />
            )
          })}
        </ul>
      )}
    </div>
  )
}
